import { IconButtonProps, IconButton as MuiIconButton } from '@mui/material';

const IconButton = (props: IconButtonProps) => {
  return <MuiIconButton {...props} />;
};

export default IconButton;
